import createIcon from '../../createIcon';

/**
 * @component @name Alarm
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgNS43OUwxNy40IDEuOTNMMTYuMTEgMy40NkwyMC43MSA3LjMyTDIyIDUuNzlaTTcuODggMy40Nkw2LjYgMS45M0wyIDUuNzhMMy4yOSA3LjMxTDcuODggMy40NlpNMTIuNSA4LjA3SDExVjE0LjA3TDE1Ljc1IDE2LjkyTDE2LjUgMTUuNjlMMTIuNSAxMy4zMlY4LjA3Wk0xMiA0LjA3QzcuMDMgNC4wNyAzIDguMSAzIDEzLjA3QzMgMTguMDQgNy4wMiAyMi4wNyAxMiAyMi4wN0MxNi45NyAyMi4wNyAyMSAxOC4wNCAyMSAxMy4wN0MyMSA4LjEgMTYuOTcgNC4wNyAxMiA0LjA3Wk0xMiAyMC4wN0M4LjEzIDIwLjA3IDUgMTYuOTQgNSAxMy4wN0M1IDkuMiA4LjEzIDYuMDcgMTIgNi4wN0MxNS44NyA2LjA3IDE5IDkuMiAxOSAxMy4wN0MxOSAxNi45NCAxNS44NyAyMC4wNyAxMiAyMC4wN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Alarm = createIcon('Alarm', [
  [
    'path',
    {
      d: 'M22 5.79L17.4 1.93L16.11 3.46L20.71 7.32L22 5.79ZM7.88 3.46L6.6 1.93L2 5.78L3.29 7.31L7.88 3.46ZM12.5 8.07H11V14.07L15.75 16.92L16.5 15.69L12.5 13.32V8.07ZM12 4.07C7.03 4.07 3 8.1 3 13.07C3 18.04 7.02 22.07 12 22.07C16.97 22.07 21 18.04 21 13.07C21 8.1 16.97 4.07 12 4.07ZM12 20.07C8.13 20.07 5 16.94 5 13.07C5 9.2 8.13 6.07 12 6.07C15.87 6.07 19 9.2 19 13.07C19 16.94 15.87 20.07 12 20.07Z',
      key: 'yg6zya',
    },
  ],
]);

export default Alarm;
